import {inject, Injectable} from '@angular/core';
import {ExtendedAsyncValidateFunction, ExtendedAsyncValidator, ObjectValidators} from '@aviary/forms/extensions/form-extensions.types';
import {Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {RegistrationActions} from '@store/registration/registration.actions';
import {createExtendedAsyncValidator} from '@aviary/forms/extensions/form-extensions.helpers';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {
  CreatePasswordValue,
  DetailsValue,
  EmailVerificationRequest,
  EmailVerificationValue,
  NotificationPreferencesValue
} from '@store/registration/registration.types';
import {CommonValidators} from '@aviary/store/common/common.validators';
import {DateValidators} from '@aviary/forms/fields/date-form-field/date.form-validators';

@Injectable({providedIn: 'root'})
export class RegistrationValidators {
  private readonly patronEmailAvailableValidator: PatronEmailAvailableValidator = inject(PatronEmailAvailableValidator);

  public readonly emailFormValidator: ObjectValidators<EmailVerificationRequest> = {
    email: {
      validators: [Validators.required, Validators.email, Validators.maxLength(256)],
      asyncValidators: this.patronEmailAvailableValidator.validate
    },
  };

  public readonly verifyEmail: ObjectValidators<EmailVerificationValue> = {
    verificationCode: [Validators.required, CommonValidators.verificationCodeValidator]
  }

  public readonly createPassword: ObjectValidators<CreatePasswordValue> = {
    password: [],
    branchId: [],
    acceptTerms: [Validators.requiredTrue],
  }

  public readonly enterDetails: ObjectValidators<DetailsValue> = {
    firstName: [Validators.required, Validators.maxLength(256)],
    lastName: [Validators.required, Validators.maxLength(256)],
    suffix: [],
    address: [Validators.required, Validators.maxLength(64)],
    address2: [Validators.maxLength(32)],
    city: [Validators.required, Validators.maxLength(32)],
    state: [],
    zip: [Validators.required, CommonValidators.zipCodeValidator],
    branchId: [],
    dateOfBirth: [Validators.required, DateValidators.pastDate],
  }

  public readonly setNotificationPrefs: ObjectValidators<NotificationPreferencesValue> = {
    notificationEmail: [Validators.email, Validators.maxLength(320)],
    mobilePhone: [CommonValidators.phoneNumber, Validators.maxLength(18)],
    notifyMethod: [],
    smsTermsAccepted: [Validators.requiredTrue],
  }
}

@Injectable({providedIn: 'root'})
export class PatronEmailAvailableValidator implements ExtendedAsyncValidator {
  public readonly validate: ExtendedAsyncValidateFunction = createExtendedAsyncValidator({
    store: inject(Store),
    validationActionCreator: RegistrationActions.validatePatronEmailAvailable,
    validitySelector: RegistrationSelectors.EmailValidation.isAvailable,
    validationErrorKey: 'patronEmailUnavailable'
  });
}
